'use strict';

var moduleName = 'EmployerOccupationRetiredCheckboxView';
var moduleDependencies = ['backbone', 'CheckboxView'];
var moduleView = function (Backbone, CheckboxView) {
  //var $ = Backbone.$;
  //var _ = Backbone._;

  return CheckboxView.extend({
    __name__ : moduleName,
    events : {
      'change input': 'onInputChanged'
    },
    errors: function () {
      // This checkbox doesn't have any validation to do
      // The validation occurs as it normally would for the
      // Occupation and Employer textfields
      return [];
    },
    val: function () {
      return this.$(':input').prop('checked');
    },
    setval: function(value) {
      this.$(':input').prop('checked', value);
      return this.touch();
    },
    onInputChanged: function ()
    {
      var isRetired = this.val();
      var occupationView = this.parent._getChildViewNamed('Occupation');
      var employerView = this.parent._getChildViewNamed('Employer');

      if (isRetired)
      {
        occupationView.input.setAttribute('disabled', 'true');
        employerView.input.setAttribute('disabled', 'true');

        occupationView.setval(this.resources.PrimaryResources.Retired);
        employerView.setval(this.resources.PrimaryResources.Retired);

        occupationView.renderFeedbackWithErrors(occupationView.errors());
        employerView.renderFeedbackWithErrors(employerView.errors());
      }
      else
      {
        occupationView.setval(null);
        employerView.setval(null);

        // Don't render error feedback on uncheck per design

        occupationView.input.removeAttribute('disabled');
        employerView.input.removeAttribute('disabled');
      }
    },
    type: 'employer_occupation_retired_checkbox'
  });
};

define(moduleName, moduleDependencies, moduleView);

define("EmployerOccupationRetiredCheckboxView", function(){});

